import { useNavigate } from '@tanstack/react-router'
import { Icon } from '@/common/components/icon'
import { useImpersonation } from '@/common/hooks/useImpersonation'
import * as styles from './ImpersonationBanner.css'

export function ImpersonationBanner() {
  const { isImpersonating, impersonatedEmployeeName, stopImpersonating } = useImpersonation()
  const navigate = useNavigate()

  if (!isImpersonating) return null

  const handleStop = () => {
    stopImpersonating()
    navigate({ to: '/org' })
  }

  return (
    <div className={styles.banner} role="status">
      <div className={styles.icon}>
        <Icon name="visibility" size={18} />
      </div>
      <span className={styles.label}>Viewing as</span>
      <span className={styles.name}>{impersonatedEmployeeName}</span>
      <div className={styles.spacer} />
      <button type="button" className={styles.stopButton} onClick={handleStop}>
        Stop Impersonating
      </button>
    </div>
  )
}
